import { AxiosService } from 'src/services/AxiosService';
import {GrouperServiceConverter} from 'src/services/converters/GrouperServiceConverter';
import {DrgAnalyseResponseDto} from 'src/contracts/drgAnalyseResponseDto';
import {DrgAnalysis} from 'src/contracts/drgAnalysis';
import {AnalyzeDrgRequestDto} from 'src/contracts/analyzeDrgRequestDto';
import {GetResearchResponse} from 'src/contracts/getMetadataResearchResponse';

/**
 * Service for interacting with the backend Grouper V3 service.
 */
export class ResourceService extends AxiosService {
  async analyzeDRG(request: AnalyzeDrgRequestDto | undefined): Promise<DrgAnalysis | undefined> {
    const result =  await this.axiosCall<DrgAnalyseResponseDto>({
      method: 'post',
      data: request,
      url: `/grouper/drg/analyze/${encodeURIComponent(this.facilityCode)}`,
    });

    if (result.err) {
      console.log(`[ResourceService] Error: ${(<Error>result.err).message}`);
      return undefined;
    }

     return <DrgAnalysis>GrouperServiceConverter.convertDrgAnalyseData(<DrgAnalyseResponseDto>result.data);
  }

  async researchData(code: string, codeType: string): Promise<GetResearchResponse | undefined> {
    const result =  await this.axiosCall<GetResearchResponse>({
      method: 'get',
      url: `/grouper/${this.facilityCode}/research/${encodeURIComponent(codeType)}/${encodeURIComponent(code)}?all=true`,
    });

    if (result.err) {
      console.log(`[ResourceService] Error: ${(<Error>result.err).message}`);
      return undefined;
    }
    return result.data;
  }
}